import { render, staticRenderFns } from "./PricePreResa.vue?vue&type=template&id=4106bfe8&"
import script from "./PricePreResa.vue?vue&type=script&lang=js&"
export * from "./PricePreResa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports